import React, { useState, useEffect } from "react";
import { createUser, sendEmail, signOutUser } from "../firebase/auth";
import { register } from "../utils/api";
import { useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/authContext";
import { useLoading } from "./Loading";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import db, { storage } from "../firebase/firebaseConfig";
import { addDoc, doc, setDoc, Timestamp } from "firebase/firestore";
import { toZonedTime } from "date-fns-tz";
import { deleteUser } from "firebase/auth";

function Register() {
  // State to track the selected form
  const [selectedForm, setSelectedForm] = useState("");
  const navigate = useNavigate();
  const [termsAgreed, setTermsAgreed] = useState(false);
  const { initializeUser } = useAuth();
      const {setLoading} = useLoading();
      const {currentUser} = useAuth();
  
      useEffect(()=>{
          setTimeout(() => {
              setLoading(false);
          }, 10);
          if(currentUser)
            {
                navigate('/');
            }
      },[])
  const malaysiaStates = [
    "Johor",
    "Kedah",
    "Kelantan",
    "Malacca",
    "Negeri Sembilan",
    "Pahang",
    "Perak",
    "Perlis",
    "Penang",
    "Sabah",
    "Sarawak",
    "Selangor",
    "Terengganu",
    "Kuala Lumpur",
  ];
  const [adopterData, setAdopterData] = useState({
    name: "",
    icNumber: "",
    age: "",
    address: "",
    phoneNumber: "",
    gender: "",
    email: "",
    city:"",
    state:"",
    postcode:"",
    password: "",
    status:"Active",
  });

  const [icError, setIcError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [shelterData, setShelterData] = useState({
    shelterName: "",
    address: "",
    email: "",
    phoneNumber: "",
    contactPerson: "",
    icNumber: "",
    licenseFile: null,
    password: "",
    status: "Pending",
    city:"",
    state:"",
    postcode:"",
  });

  // Function to handle button clicks
  const handleFormSelect = (formType) => {
    resetFields();
    setIcError("");
    setPhoneError("");
    setSelectedForm(formType);
  };
// Function to reset all fields
  const resetFields = () => {
    setTermsAgreed(false);
    // Reset adopter fields
    setAdopterData({
      name: "",
      icNumber: "",
      age: "",
      address: "",
      phoneNumber: "",
      gender: "",
      email: "",
      password: "",
      city:"",
      state:"",
      postcode:"",
      status:"Active",
    });

    // Reset shelter fields
    setShelterData({
      shelterName: "",
      address: "",
      email: "",
      phoneNumber: "",
      contactPerson: "",
      icNumber: "",
      licenseFile: null,
      password: "",
      city:"",
      state:"",
      postcode:"",
      status: "Pending"
    });
  };
   // IC Number Validation
   const validateIcNumber = (value) => {
    const icPattern = /^\d{6}-\d{2}-\d{4}$/; // xxxx-xx-xxxx
    if (!icPattern.test(value)) {
      setIcError("IC Number must be in the format xxxxxx-xx-xxxx.");
      return false;
    } else {
      setIcError("");
      return true;
    }
  };

  // Phone Number Validation
  const validatePhoneNumber = (value) => {
    const phonePattern = /^\+601\d-\d{7,8}$/; // xxx-xxxxxxx or xxx-xxxxxxxx
    if (!phonePattern.test(value)) {
      setPhoneError("Phone Number must be in the format +601x-xxxxxxx.");
      return false;
    } else {
      setPhoneError("");
      return true;
    }
  };


  //Need to check account exist or not
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedForm === "adopter") {
      validateIcNumber(adopterData.icNumber);
      validatePhoneNumber(adopterData.phoneNumber);
    }
    else {
      validateIcNumber(shelterData.icNumber);
      validatePhoneNumber(shelterData.phoneNumber);
    }
    if(!termsAgreed)
    {
      alert('Please agree to the Terms and Privacy Policy.');
      return;
    }
    if (selectedForm === "adopter" && adopterData?.password?.length >=6 &&adopterData?.postcode?.length===5 
      && adopterData.state!=="" && !icError && !phoneError && (/^\d{6}-\d{2}-\d{4}$/).test(adopterData.icNumber)
      &&(/^\+601\d-\d{7,8}$/).test(adopterData.phoneNumber)){
      setLoading(true);
      try {
        const userCredential = await createUser(adopterData.email, adopterData.password);
        const user = userCredential.user;
        const { password, ...adopterDataWithoutPassword } = adopterData;
        const dataToSend = {
          uid: user.uid,
          selectedForm,
          ...adopterDataWithoutPassword, // Spread adopterData object
        };
        const data = await register(dataToSend);

        await user.reload();
        await user.getIdToken(true);
        await initializeUser(user);

        await sendEmail();
        await signOutUser();
        setLoading(false);
        alert(data.message);
        navigate('/login');
      }
      catch (error) {
        setLoading(false);
        if(error.message==="Firebase: Error (auth/email-already-in-use).")
        alert("Email already in use");
        console.log(error);
      }
    }
    else if (selectedForm === "shelter"&& shelterData?.password?.length >=6 && shelterData?.postcode?.length===5 
      && shelterData.state!=="" && !icError && !phoneError&& (/^\d{6}-\d{2}-\d{4}$/).test(shelterData.icNumber)
      &&(/^\+601\d-\d{7,8}$/).test(shelterData.phoneNumber)) {
      setLoading(true);
      let user = null; 
      try {
        const userCredential = await createUser(shelterData.email, shelterData.password);
        user = userCredential.user;
        const { password, ...shelterDataWithoutPassword } = shelterData;

        const fileExtension = shelterData.licenseFile.name.split('.').pop();
        const newFileName = `${user.uid}_${Date.now()}.${fileExtension}`;
        const storageRef = ref(storage, `ShelterLicense/${newFileName}`);
        const storageSnap = await uploadBytes(storageRef, shelterData.licenseFile);
        const zonedDate = toZonedTime(new Date(), 'Asia/Kuala_Lumpur');
        const formattedTime = Timestamp.fromDate(zonedDate);
        const dataToSend = {
          uid: user.uid,
          selectedForm,
          ...shelterDataWithoutPassword,
        };
        const shelterRef = doc(db, "Shelters", user.uid);
        await setDoc(shelterRef, {
          ...shelterDataWithoutPassword,
          licenseFile: newFileName,
          timestamp: formattedTime,
        });
        const data = await register(dataToSend);        
        await signOutUser();

        setLoading(false);
        alert(data.message);
        navigate('/login')
      }
      catch (error) {
        setLoading(false);
        if(error.message==="Firebase: Error (auth/email-already-in-use).")
        alert("Email already in use");
        if (user) {
          try {
            await deleteUser(user);
            console.log(`User ${user.uid} deleted due to registration error.`);
          } catch (deleteError) {
            console.error(`Error deleting user ${user.uid}:`, deleteError);
            // Handle the delete error (e.g., log it, show a message)
          }
        }
      }
    }
  };

  return (
      <div className="registerContainer">
          <div className="registerForm">
              <h1>Choose Your Role</h1>
              <div className="rolesBtn">
                  <button
                      onClick={() => handleFormSelect("adopter")}
                  >
                    <img src="/adopter.png" alt="adopter"></img>
                      Adopter
                  </button>
                  <button
                      onClick={() => handleFormSelect("shelter")}
                  >
                    <img src="/shelter.png" alt="shelter"></img>
                      Animal Shelter
                  </button>
              </div>

              {selectedForm === "adopter" && (
                  <div className="adopterForm">
                      <form onSubmit={handleSubmit}>
                          <h2>Adopter Registration</h2>
                          <input type="text" placeholder="Full Name" value={adopterData.name} 
                          onChange={(e)=>setAdopterData({ ...adopterData, name: e.target.value })} required />
                          
                          <input type="text" placeholder="IC Number" value={adopterData.icNumber} 
                          onChange={(e)=>setAdopterData({ ...adopterData, icNumber: e.target.value })} onBlur={(e)=>validateIcNumber(e.target.value)} 
                          required />
                          {icError && <p className="errorMessage">{icError}</p>}

                          <input type="number" placeholder="Age" value={adopterData.age} min="12" max="100"
                          onChange={(e)=>setAdopterData({ ...adopterData, age: e.target.value })} required />

                          <input type="text" placeholder="Address" value={adopterData.address}
                           onChange={(e)=>setAdopterData({ ...adopterData, address: e.target.value })} required />

                          <input type="text" placeholder="Postcode" value={adopterData.postcode} required
                          maxLength={5}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                            if (/^\d{0,5}$/.test(value)) { 
                              setAdopterData(prev => ({ ...prev, postcode: value }));
                            }
                          }}
                          />
                          {adopterData?.postcode?.length < 5 && adopterData?.postcode.length > 0 && (
                            <p className="errorMessage">Postcode must be exactly 5 digits</p>
                          )}
                          <input type="text" placeholder="City" value={adopterData.city} required
                          onChange={(e)=>setAdopterData({...adopterData, city:e.target.value})}/>

                          <select value={adopterData.state} onChange={(e) => setAdopterData({ ...adopterData, state: e.target.value })} required>
                          <option value="">Choose State</option>
                            {malaysiaStates.map((state)=>(
                              <option key={state} value={state}>{state}</option>
                            ))}
                          </select>

                          <input type="text" placeholder="Phone Number" value={adopterData.phoneNumber} 
                          onChange={(e)=>setAdopterData({ ...adopterData, phoneNumber: e.target.value })} onBlur={(e)=>validatePhoneNumber(e.target.value)} 
                          required />
                          {phoneError && <p className="errorMessage">{phoneError}</p>}

                          <select value={adopterData.gender} onChange={(e)=>setAdopterData({ ...adopterData, gender: e.target.value })} required>
                            <option value="">Choose Gender</option>
                            <option value="Female" >Female</option>
                            <option value="Male">Male</option>
                          </select>

                          <input type="email" placeholder="Email Address" value={adopterData.email}
                          onChange={(e)=>setAdopterData({ ...adopterData, email: e.target.value })} required />

                          <input type="password" placeholder="Password" value={adopterData.password}
                          onChange={(e)=>setAdopterData({ ...adopterData, password: e.target.value })} required />
                          {adopterData.password && adopterData?.password.length < 6 && (
                            <p className="errorMessage">Password must be more than 6 characters</p>
                          )}
                        <div style={{ marginTop: "18px", display:"flex", alignItems:"center"}}>
                         
                            <input
                            style={{ margin:"0px", width:"20px", alignSelf:"center" }}
                              type="checkbox"
                              checked={termsAgreed}
                              onChange={(e) => setTermsAgreed(e.target.checked)}
                              required
                            /> 
                            <label style={{ textAlign:"left", fontSize: "clamp(0.5rem, 2vw, 1rem)", margin:"0px 5px" }}>
                            I have read and agree to the <a href="/terms" target="_blank">Terms of Service</a> and 
                            <a href="/privacy" target="_blank"> Privacy Policy</a>.
                          </label>
                        </div>
                          <button type="submit" >Register</button>
                      </form>
                  </div>
              )}

              {selectedForm === "shelter" && (
                  <div className="shelterForm">
                    {icError===""&&phoneError===""}
                      <form onSubmit={handleSubmit}>
                          <h2>Animal Shelter Registration</h2>
                          <input type="text" value={shelterData.shelterName} 
                          onChange={(e) => setShelterData({ ...shelterData, shelterName: e.target.value })}
                          placeholder="Shelter Name" required />

                          <input type="text" value={shelterData.address} 
                          onChange={(e) => setShelterData({ ...shelterData, address: e.target.value })}
                          placeholder="Shelter Address" required />

                        <input type="text" placeholder="Postcode" value={shelterData.postcode} required
                          maxLength={5}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                            if (/^\d{0,5}$/.test(value)) { 
                              setShelterData(prev => ({ ...prev, postcode: value }));
                            }
                          }}
                          />
                          {shelterData?.postcode?.length < 5 && shelterData?.postcode.length > 0 && (
                            <p className="errorMessage">Postcode must be exactly 5 digits</p>
                          )}
                          <input type="text" placeholder="City" value={shelterData.city} required
                          onChange={(e)=>setShelterData({...shelterData, city:e.target.value})}/>

                          <select value={shelterData.state} onChange={(e) => setShelterData({ ...shelterData, state: e.target.value })} required>
                          <option value="">Choose State</option>
                            {malaysiaStates.map((state)=>(
                              <option key={state} value={state}>{state}</option>
                            ))}
                          </select>

                          <input type="text" value={shelterData.phoneNumber} 
                          onChange={(e) => setShelterData({ ...shelterData, phoneNumber: e.target.value })}
                          placeholder="Phone Number" onBlur={(e)=>validatePhoneNumber(e.target.value)} required />
                          {phoneError && <p className="errorMessage">{phoneError}</p>}

                          <input type="text" value={shelterData.contactPerson} 
                          onChange={(e) => setShelterData({ ...shelterData, contactPerson: e.target.value })}
                          placeholder="Contact Person Name" required />

                          <input type="text" value={shelterData.icNumber} 
                          onChange={(e) => setShelterData({ ...shelterData, icNumber: e.target.value })}
                          placeholder="Contact Person IC Number" onBlur={(e)=>validateIcNumber(e.target.value)} required />
                          {icError && <p className="errorMessage">{icError}</p>}

                          <label>
                          <p>License File (PDF, JPG, PNG):</p>
                          <input type="file" className="form-control" name="licenseFile" placeholder="License File" accept=".pdf,.jpg,.jpeg,.png" 
                          onChange={(e)=> setShelterData({ ...shelterData, licenseFile: e.target.files[0] })} required />
                          </label>
                          
                          <input type="email" value={shelterData.email} 
                          onChange={(e) => setShelterData({ ...shelterData, email: e.target.value })}
                          placeholder="Email Address" required />

                          <input type="password" value={shelterData.password} 
                          onChange={(e) => setShelterData({ ...shelterData, password: e.target.value })}
                          placeholder="Password" required />
                          {shelterData.password && shelterData?.password.length < 6 && (
                            <p className="errorMessage">Password must be more than 6 characters</p>
                          )}

                        <div style={{marginTop: "18px", display:"flex", alignItems:"center"}}>
                         <input
                         style={{ margin:"0px", width:"20px" }}
                           type="checkbox"
                           checked={termsAgreed}
                           onChange={(e) => setTermsAgreed(e.target.checked)}
                           required
                         /> 
                         <label style={{ textAlign:"left", fontSize: "clamp(0.5rem, 2vw, 1rem)", whiteSpace: "break-spaces",  display: 'inline-block', margin:"0px 5px" }}>
                         I have read and agree to the <a href="/terms" target="_blank">Terms of Service</a> and <a href="/privacy" target="_blank">Privacy Policy</a>.
                       </label>
                     </div>
                          <button type="submit" >Register</button>
                      </form>
                  </div>
              )}
              <p>Already have an account? <a href="/login">Sign In</a></p>
          </div>
      </div>
  );
};

export default Register;

